function getTitleAdditionForUrl() {
    var currentPlace = document.location.hash;
    var title = "";
    if (currentPlace.indexOf("#start-booking?") !== -1) {
        title = " - Check-In Details";
    } else if (currentPlace.indexOf("#login?") !== -1 && currentPlace.indexOf("tab=register") !== -1) {
        title = " - Register for an Account";
    } else if (currentPlace.indexOf("#start-wait-list?") !== -1) {
        title = " - Check-In Details";
    } else if (currentPlace.indexOf("#login?") !== -1) {
        title = " - Login/Register";
    } else if (currentPlace.indexOf("#waiting-list?") !== -1) {
        title = " - Check-In Waitlist";
    }
    return title;
}
module.exports = getTitleAdditionForUrl;